import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatDeShortDateTime } from "@/lib/date";

export default function AccessRightsLog({ userId, groups, refreshKey }) {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    api.get(`/users/${userId}/permissions/log`).then((r) => setRows(r.data)).catch(() => setRows([]));
  }, [userId, refreshKey]);
  const labels = Object.fromEntries(groups.flatMap((g) => g.areas.map((a) => [a.key, a.label])));
  const names = (keys) => keys.map((k) => labels[k] || k).join(", ");
  return (
    <div className="mt-3 border-t border-slate-200 pt-2" data-testid={`rights-log-${userId}`}>
      <div className="text-[10px] font-bold uppercase tracking-overline text-slate-500 mb-1">Änderungsprotokoll</div>
      {rows.length === 0 ? (
        <div className="text-[11px] text-slate-400" data-testid={`rights-log-empty-${userId}`}>Noch keine Änderungen</div>
      ) : (
        <ul className="space-y-1 max-h-40 overflow-y-auto">
          {rows.map((r) => (
            <li key={r.log_id} className="text-[11px] text-slate-700" data-testid={`rights-log-entry-${r.log_id}`}>
              <span className="font-mono text-slate-500">{formatDeShortDateTime(r.at)}</span> · <b>{r.changed_by_name}</b>
              {r.added.length > 0 && <div className="text-emerald-700 pl-2">+ {names(r.added)}</div>}
              {r.removed.length > 0 && <div className="text-red-700 pl-2">− {names(r.removed)}</div>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
